import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    id: "display-name-modal",
    class: "modal min2 js-modal"
};
const _hoisted_2 = { class: "modal-content" };
const _hoisted_3 = { class: "pop" };
const _hoisted_4 = {
    key: 0,
    class: "err"
};
const _hoisted_5 = { class: "bt_box clear" };
import { ref, watch, onMounted } from 'vue';
import ImageFrame from '@component/ImageFrame.vue';
import Alert from '@util/BrowserAlert';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DisplayNameModal',
    props: {
        value: {},
        errors: {}
    },
    emits: ['input', 'cancel'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const originValue = ref('');
        const close = ref();
        // 文字数チェック
        watch(() => originValue.value, (value) => {
            if (Alert.charLimitText(value)) {
                originValue.value = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        // キャンセルボタン
        const onClickCancel = () => {
            originValue.value = props.value;
            emit('cancel');
        };
        // OKボタン
        const onClickOk = () => {
            emit('input', originValue.value);
        };
        const onCloseModal = () => {
            close.value.click();
        };
        onMounted(() => {
            originValue.value = props.value;
        });
        __expose({
            onCloseModal,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "modal-bg bt_modal_close",
                    onClick: onClickCancel
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "close_bt bt_modal_close",
                        onClick: onClickCancel
                    }, [
                        _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _cache[1] || (_cache[1] = _createElementVNode("h2", null, "表示名", -1)),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((originValue).value = $event)),
                            type: "text",
                            name: "job1",
                            class: "wmax inquiry-form",
                            placeholder: "例：山田 太郎"
                        }, null, 512), [
                            [_vModelText, originValue.value]
                        ]),
                        (props.errors)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(props.errors), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                _createElementVNode("li", null, [
                                    _createElementVNode("p", {
                                        class: "bt_modal_close bt_clear",
                                        onClick: onClickCancel
                                    }, "キャンセル")
                                ]),
                                _createElementVNode("li", null, [
                                    _createElementVNode("p", {
                                        class: "bt_ok",
                                        onClick: onClickOk
                                    }, "OK")
                                ])
                            ]),
                            _createElementVNode("p", {
                                class: "bt_modal_close",
                                ref_key: "close",
                                ref: close,
                                style: { "display": "none" }
                            }, null, 512)
                        ])
                    ])
                ])
            ]));
        };
    }
});
